import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/faro-dialog";
import { MembersAutocomplete } from "@components/common/members-autocomplete/members-autocomplete";
import { ProjectRoleAutoComplete } from "@components/role/role-autocomplete/project-role-autocomplete";
import { BaseProjectProps } from "@custom-types/project-types";
import { Button } from "@flat-ui";
import { useInviteMembersToProject } from "@hooks/projects/use-invite-members-to-project";
import { Box, Skeleton, Stack } from "@mui/material";
import { fetchingMembersFlagsSelector } from "@store/members/members-selector";
import { useAppSelector } from "@store/store-helper";

/** Renders autocomplete and role selection to invite members to project in share dialog */
export function InviteMemberToProjectDialog({
  project,
}: BaseProjectProps): JSX.Element {
  const { isFetchingCompanyMembers } = useAppSelector(
    fetchingMembersFlagsSelector
  );

  const {
    autocompleteOptions,
    selectedMembers,
    helperText,
    handleMemberSelect,
    onInputChange,
    isValidInput,
    selectedRole,
    setSelectedRole,
    isLoading,
    shouldSendInviteDisable,
    handleConfirm,
  } = useInviteMembersToProject({ project, location: "share-project-dialog" });

  if (isFetchingCompanyMembers) {
    return <Skeleton variant="rectangular" height="47px" />;
  }

  return (
    <Stack>
      <MembersAutocomplete
        isRequired
        hasAutoFocus
        label="Members"
        helperText={helperText}
        onInputChange={onInputChange}
        options={autocompleteOptions}
        selectedOptions={selectedMembers}
        handleMemberSelect={handleMemberSelect}
        isValid={isValidInput}
      />
      {selectedMembers.length > 0 && (
        <>
          <Box sx={{ mt: SPACE_ELEMENTS_OF_MODAL }}>
            <ProjectRoleAutoComplete
              isRequired={true}
              selectedRole={selectedRole}
              onChange={(role) => setSelectedRole(role)}
            />
          </Box>
          <Button
            variant="ghost"
            disabled={shouldSendInviteDisable}
            isLoading={isLoading}
            onClick={handleConfirm}
            sx={{ mt: SPACE_ELEMENTS_OF_MODAL }}
          >
            Invite
          </Button>
        </>
      )}
    </Stack>
  );
}
